import React, { useEffect, useState } from "react";
import { BaseModal } from "./FormElements/BaseModal";
import { InputSelect } from "./FormElements/InputSelect";
import Button from "./FormElements/Button";
import DatePicker from "./datePicker";

interface IModalFormBeneficiarie {
  relationship: any;
  open: boolean;
  onSubmit: () => void;
  close: () => void;
  register: any;
  setValue: (name: string, value: any) => void;
  selectedParient: any;
  errors?: any;
  salud: any;
  genrer: any;
  disabledSend: boolean;
  disabledGenrer?: boolean;
}

export const ModalFormBeneficiaries = ({
  relationship,
  open,
  onSubmit,
  close,
  register,
  setValue,
  selectedParient,
  salud,
  genrer,
  disabledSend,
  disabledGenrer,
}: IModalFormBeneficiarie) => {
  const beneficiary = selectedParient || {};
  const [localBornDate, setLocalBornDate] = useState(false);

  useEffect(() => {
    if (!open) {
      setValue("bornDate", "");
      return;
    }

    const date = (selectedParient && selectedParient.bornDate) || "";
    setValue("bornDate", date);
  }, [open, selectedParient]);

  useEffect(() => {
    if (localBornDate) {
      setValue("bornDate", localBornDate);
    }
  }, [localBornDate]);

  return (
    <BaseModal
      open={open}
      handleClose={close}
      title="Agregar Beneficiario"
      width={`${window.innerWidth}px`}
    >
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={onSubmit}
        className="p-0"
      >
        <InputSelect
          name="relationship"
          options={relationship}
          placeHolder="Parentesco"
          register={register}
          defaultValue={beneficiary.relationship || ""}
        />
        {open && (
          <div style={{ textAlign: "left" }}>
            <DatePicker
              name="bornDate"
              defaultValue={selectedParient && selectedParient.bornDate ? selectedParient.bornDate : ""}
              register={register}
              onChange={(date) => {
                setLocalBornDate(date);
              }}
            />
          </div>
        )}
        
        <InputSelect
          name="sano"
          options={salud}
          placeHolder="Salud"
          register={register}
          defaultValue={beneficiary.sano || ""}
        />
        <InputSelect
          name="genrerBenefiarie"
          options={genrer}
          placeHolder="Sexo"
          register={register}
          defaultValue={beneficiary.genrerBenefiarie || ""}
          disabled={disabledGenrer}
        />
        <div style={{ display: "flex", justifyContent: "end" }}>
          <div style={{ width: "50%" }}>
            <Button type="submit" disabled={disabledSend}>
              {selectedParient ? "Editar" : "Aceptar"}
            </Button>
          </div>
        </div>
      </form>
    </BaseModal>
  );
};
